
export const Theme = {
  mask: [
    'flex justify-center items-center absolute bg-white bg-opacity-75 top-0 left-0 w-full h-full z-[98]',
    'dark:bg-gray-800 dark:bg-opacity-75'
  ]
};
